module.exports = __webpack_public_path__ + "img/dloons_05.ada4feae.png";